import { QueryOptions } from "@apollo/client"

import { CaseStatus, GetAllClientCasesQuery, useGetAllClientCasesQuery, useGetClientUserQuery } from "@acre/graphql"

type UseGetAllCasesOptions = {
    activeCases?: boolean
    inactiveCases?: boolean
    includeProperty?: boolean
    includeClientsUser?: boolean
    onlyIncludeClientsBasicInfo?: boolean
    includeDeniedAccess?: boolean
    includeOwnerOrganisation?: boolean
    skip?: boolean
    includeDocuments?: boolean
    fetchPolicy?: QueryOptions['fetchPolicy']
    clientId?: string | null
}

export const isActiveCase = (clientCase: GetAllClientCasesQuery['allClientCases'][0]): boolean => {
    const inactiveStatuses = [
        CaseStatus.Complete,
        CaseStatus.ImportedComplete,
        CaseStatus.NotProceeding
    ]
    return !inactiveStatuses.includes(clientCase?.details?.status as CaseStatus)
}

// TODO: Optimise after migration to v3 is finished 
export const useGetAllCases = ({
    activeCases = false,
    inactiveCases = false,
    includeProperty = false,
    includeDocuments = false,
    includeDeniedAccess = false,
    includeClientsUser = false,
    includeOwnerOrganisation = false,
    onlyIncludeClientsBasicInfo = false,
    skip = false,
    fetchPolicy = 'cache-first',
    clientId,
}: UseGetAllCasesOptions) => {

    const {
        loading: loadingClient,
        error: clientError,
        data: clientData
    } = useGetClientUserQuery({ skip, fetchPolicy: fetchPolicy, nextFetchPolicy: 'cache-only' })

    const client = clientData?.clientUser
    const client_id = client?.id || clientId

    const {
        loading: clientCaseListLoading,
        error: casesError,
        data: allCases
    } = useGetAllClientCasesQuery({
        variables: {
            clientId: client_id || '',
            fromClientPortal: true,
            includeProperty,
            includeDocuments,
            includeClientsUser,
            includeOwnerOrganisation,
            onlyIncludeClientsBasicInfo,
            deniedAccess: includeDeniedAccess,
            includeDeniedCases: includeDeniedAccess,
        },
        skip: !client_id,
        fetchPolicy: fetchPolicy,
        nextFetchPolicy: 'cache-only'
    })

    const allClientCases = allCases?.allClientCases ?? null
    const activeCasesList = activeCases ? allClientCases?.filter(isActiveCase) : null
    const inactiveCasesList = inactiveCases ? allClientCases?.filter(clientCase => !isActiveCase(clientCase)) : null
    const error = clientError || casesError

    return {
        loading: loadingClient || clientCaseListLoading,
        error: error || undefined,
        cases: allClientCases,
        activeCases: activeCasesList,
        inactiveCases: inactiveCasesList,
        client,
    }
}
